
import * as ipxRuntime$JyQHGfF2ZmVwSQaArOFrVAnq5B_45V_O7vqATXPmW5fxI from '/var/www/quickbooking/node_modules/@nuxt/image/dist/runtime/providers/ipx'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [
    "googleusercontent.com",
    "quickbooking.it"
  ],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp",
    "webp"
  ],
  "quality": 87
}

imageOptions.providers = {
  ['ipx']: { provider: ipxRuntime$JyQHGfF2ZmVwSQaArOFrVAnq5B_45V_O7vqATXPmW5fxI, defaults: {} }
}
        